module.exports = __webpack_public_path__ + "static/media/031.78d4b464.jpg";